import { useState } from "react";
import { Plus, Minus, Search } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export function FAQAccordion({ faqs, searchable = false }) {
  const [open, setOpen] = useState(0);
  const [query, setQuery] = useState("");
  const filtered = query
    ? faqs.filter((f) => (f.q + f.a + (f.cat || "")).toLowerCase().includes(query.toLowerCase()))
    : faqs;

  return (
    <div data-testid="faq-accordion">
      {searchable && (
        <div className="relative mb-8 max-w-md">
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-muted" />
          <input value={query} onChange={(e) => setQuery(e.target.value)} placeholder="Search FAQs…" data-testid="faq-search"
            className="w-full border border-[#E3E8EF] bg-white py-3.5 pl-11 pr-4 text-sm text-maintext outline-none transition-colors focus:border-ink focus-ring" />
        </div>
      )}
      <div className="divide-y divide-[#E3E8EF] border-y border-[#E3E8EF]">
        {filtered.map((f, i) => {
          const isOpen = open === i;
          return (
            <Reveal key={i} className="">
              <button onClick={() => setOpen(isOpen ? -1 : i)} data-testid={`faq-item-${i}`}
                className="flex w-full items-center justify-between gap-4 py-5 text-left group focus-ring">
                <span className="flex items-center gap-3">
                  {f.cat && <span className="hidden sm:inline bg-canvas px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-amber-hover">{f.cat}</span>}
                  <span className="font-display uppercase text-lg sm:text-xl tracking-wide text-ink group-hover:text-amber-hover transition-colors">{f.q}</span>
                </span>
                <span className="shrink-0 border border-[#E3E8EF] p-1.5 text-ink">{isOpen ? <Minus className="w-4 h-4" /> : <Plus className="w-4 h-4" />}</span>
              </button>
              <div className={`grid transition-[grid-template-rows] duration-300 ease-out ${isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`}>
                <div className="overflow-hidden">
                  <p className="pb-6 pr-10 text-[16px] leading-relaxed text-muted">{f.a}</p>
                </div>
              </div>
            </Reveal>
          );
        })}
        {filtered.length === 0 && <p className="py-8 text-center text-muted">No matching questions found.</p>}
      </div>
    </div>
  );
}
